import { render, staticRenderFns } from "./ReferralsStatus.vue?vue&type=template&id=7c309319"
import script from "./ReferralsStatus.vue?vue&type=script&lang=js"
export * from "./ReferralsStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports